import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Button
} from "@mui/material";
import { IoIosStar, IoIosStarHalf } from "react-icons/io";
import { IoCartOutline } from "react-icons/io5";
import { IoIosHeartEmpty, IoMdHeart } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { pickSizePackPrice } from './selectPriceForProduct';
import { formatUSD } from './formatUSD ';

const ProductCard = ({ productDetail }) => {
  const [wishlistAdd, setWishlistAdd] = useState(false);
  const handleToggle = () => {
    setWishlistAdd(!wishlistAdd);
  };

  // console.log(productDetail)
  const { images = [], name = null, price, brand = null, discountPrice, ratingNumber, by, tag, attributes, isPriceDisplay } = productDetail;
  const navigate = useNavigate()

  // const handleGetDetailProduct = (id) => {
  //   console.log(id)
  //   navigate("/lifeline/product-details", { state: { id } });
  // }

  const details = useMemo(
    () => pickSizePackPrice(productDetail?.attributes, null, null, name),
    [productDetail.attributes]
  );
  return (
    <Box
      sx={{
        border: "1px solid #ECECEC",
        width: "100%",
        borderRadius: "16px",
      }}
    >
      <Box
        sx={{
          height: "206px",
          padding: "10px",
          paddingBottom: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          "& span.tag": {
            position: "absolute",
            top: "0",
            left: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#F74B81",
            color: "#fff",
            width: "60.23px",
            height: "31px",
            borderTopLeftRadius: "15px",
            borderBottomRightRadius: "20px",
            fontSize: "12px",
            lineHeight: "12px",
            fontFamily: `"Lato", sans-serif`,
            fontWeight: "400",
            "& img": {
              width: "100%",
              objectFit: "contain",
              display: "block",
              height: "100%",
            },
          },
        }}
      >
        {/* {tag ? <span className="tag">{tag}</span> : ""} */}
        {images?.[0] ? (
          <img src={images[0]} alt="category Icon" className="cat-icon"
            width={200}
            height={200}
            style={{ objectFit: 'cover' }}

          />
        ) : null}

        {/* {categoryIcon} */}
      </Box>
      <Box
        sx={{
          // padding:'20px',
          padding: "15px",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "19.2px",
            fontWeight: "700",
            fontFamily: `"Quicksand", sans-serif`,
            // height: "40px",
            color: "#253D4E",
            display: "block",
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden !important",
            textOverflow: "ellipsis"
          }}
        >
          {name}{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: "400",
            fontFamily: `"Lato", sans-serif`,
            color: "#B6B6B6",
            marginTop: "5px",
            "& .ratingIcons svg": {
              color: "#FFC700",
              fontSize: "14px",
            },
          }}
        >
          {/* <span className="ratingIcons">
            <IoIosStar />
            <IoIosStar />
            <IoIosStar />
            <IoIosStar />
            <IoIosStarHalf />
          </span> */}
          {/* <span>(</span> {ratingNumber} <span>)</span> */}
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            lineHeight: "24px",
            fontWeight: "400",
            fontFamily: `"Lato", sans-serif`,
            color: "#B6B6B6",
            "& span": {
              color: "#000",
            },
          }}
        >
          Brand <span>{brand.length ? brand.substring(0, 22) + "..." : brand}
          </span>
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "15px",
          }}
        >
          <Typography
            sx={{
              //  fontSize:'17px',
              fontSize: "15px",
              lineHeight: "24px",
              fontWeight: "700",
              fontFamily: `"Quicksand", sans-serif`,
              color: "#253D4E",
              "& span": {
                // color: "#ADADAD",
                // fontSize: "15px",
                // paddingLeft: "5px",
              },
            }}
          >
            {/* {price}
                     {discountPrice ? (
                       <span>
                         <strike>{discountPrice}</strike>
                       </span>
                     ) : (
                       ""
                     )} */}

            {details && isPriceDisplay && (
              <>
                <span>{formatUSD(details?.finalPrice)}</span>
                {/* {details.discountPercent > 0 && (
                  <span style={{ marginLeft: 8, textDecoration: 'line-through', color: '#777' }}>
                    {formatUSD(details.retailPrice)}
                  </span>
                )} */}
              </>
            )}

          </Typography>
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "5px"
          }}>
            <Button
              onClick={handleToggle}
              sx={{ minWidth: "auto" }}>
              {wishlistAdd ?
                <IoMdHeart />
                :
                <IoIosHeartEmpty />
              }
            </Button>
            <Button
              //  variant={contained}
              sx={{
                // width:'84.91px',
                width: "70px",
                height: "36px",
                borderRadius: "4px",
                backgroundColor: "#D7EDFF",
                color: "#008BFF",
                fontSize: "14px",
                lineHeight: "24px",
                fontWeight: "700",
                fontFamily: `"Lato", sans-serif`,
                "& svg": {
                  color: "#008BFF",
                  fontSize: "14px",
                },
              }}
              onClick={() => navigate("/cart")}
            >
              <IoCartOutline />
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>

  );
}

export default ProductCard;
